import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DrawerComponent } from './components/drawer/drawer.component';
import { NavHeaderComponent } from './components/nav-header/nav-header.component';
import { LoginComponent } from './components/login/login.component';
import { FormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ResetPasswordDialogComponent } from './components/reset-password-dialog/reset-password-dialog.component';
import { OpenTicketsComponent } from './components/open-tickets/open-tickets.component';
import { NewTicketComponent } from './components/new-ticket/new-ticket.component';
import { ZonasComponent } from './components/zonas/zonas.component';
import { RepuestosComponent } from './components/repuestos/repuestos.component';
import { TecnicosComponent } from './components/tecnicos/tecnicos.component';
import { TecnicoComponent } from './components/tecnico/tecnico.component';
import { TicketComponent } from './components/ticket/ticket.component';
import { AuthInterceptorService } from './services/http-interceptor';
import { UnauthorizedResponseInterceptor } from './services/unauthorized-response-interceptor.service';
import { NuevoTecnicoComponent } from './components/nuevo-tecnico/nuevo-tecnico.component';
import { AdminsComponent } from './components/admins/admins.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmService } from './components/confirm/confirm.service';
import { StepperComponent } from './components/stepper/stepper.component';
import { AsignarTecnicoComponent } from './components/asignar-tecnico/asignar-tecnico.component';
import { AsignarTecnicoService } from './components/asignar-tecnico/asignar-tecnico.service';
import { TrashComponent } from './components/trash/trash.component';
import { AgregarZonaComponent } from './components/agregar-zona/agregar-zona.component';
import { AgregarZonaService } from './components/agregar-zona/agregar-zona.service';
import { AsignarFechaComponent } from './components/asignar-fecha/asignar-fecha.component';
import { AsignarFechaService } from './components/asignar-fecha/asignar-fecha.service';
import { StepperPedidoComponent } from './components/stepper-pedido/stepper-pedido.component';
import { RepuestosFilter } from './components/repuestos/repuestos-filter';
import { AdminsFilter } from './components/admins/admins-filter';
import { CalificarConsultaComponent } from './components/calificar-consulta/calificar-consulta.component';
import { StarsMeterComponent } from './components/stars-meter/stars-meter.component';
import { RankingTecnicosComponent } from './components/ranking-tecnicos/ranking-tecnicos.component';
import { AgregarRepuestoDialogComponent } from './components/agregar-repuesto-dialog/agregar-repuesto-dialog.component';
import { AgregarRepuestoDialogServie } from './components/agregar-repuesto-dialog/agregar-repuesto-dialog.service';
import { TicketFilter } from './filters/tickets.filter';
import { MapChartComponent } from './components/map-chart/map-chart.component';
import { AdminTicketReviewDialogComponent } from './components/admin-ticket-review-dialog/admin-ticket-review-dialog.component';
import { AdminTicketReviewDialogService } from './components/admin-ticket-review-dialog/admin-ticket-review-dialog.service';
import { ListadoRepuestosComponent } from './components/listado-repuestos/listado-repuestos.component';
import { AsignacionesTecnicoComponent } from './components/asignaciones-tecnico/asignaciones-tecnico.component';
import { RankingTecnicoParticularComponent } from './components/ranking-tecnico-particular/ranking-tecnico-particular.component';
import { NuevaSolicitudDeReppuestosComponent } from './components/nueva-solicitud-de-reppuestos/nueva-solicitud-de-reppuestos.component';
import { NuevaSolicitudDeRepuestosService } from './components/nueva-solicitud-de-reppuestos/nueva-solicitud-de-repuestos.service';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { OrdenarAlfabeticamentePipe } from './components/tecnicos/ordenar-alfabeticamente.pipe';
import { ListadoFallasComponent } from './components/listado-fallas/listado-fallas.component';
import { FallasFilter } from './components/listado-fallas/fallas-filter';
import { TecnicosModificacioinesComponent } from './components/tecnicos-modificacioines/tecnicos-modificacioines.component';
import { ActualizacionMasivaPreciosFallasComponent } from './components/actualizacion-masiva-precios-fallas/actualizacion-masiva-precios-fallas.component';
import { ActualizacionMasivaPreciosFallasService } from './components/actualizacion-masiva-precios-fallas/actualizacion-masiva-precios-fallas.service';
import { ConfigComponent } from './components/config/config.component';
import { ImportarProductosComponent } from './components/listado-repuestos/importar-productos/importar-productos.component';
import { ImportarRepuestosComponent } from './components/listado-repuestos/importar-repuestos/importar-repuestos.component';
import { MaterialModule } from './material.module';
import { MyTicketsComponent } from './components/my-tickets/my-tickets.component';
import { TerminosComponent } from './terminos/terminos.component';
import { WhatsappMessagesComponent } from './components/whatsapp-messages/whatsapp-messages.component';


@NgModule({
  declarations: [
    AppComponent,
    DrawerComponent,
    NavHeaderComponent,
    LoginComponent,
    ResetPasswordDialogComponent,
    OpenTicketsComponent,
    NewTicketComponent,
    ZonasComponent,
    RepuestosComponent,
    TecnicosComponent,
    TecnicoComponent,
    TicketComponent,
    NuevoTecnicoComponent,
    AdminsComponent,
    ConfirmComponent,
    StepperComponent,
    AsignarTecnicoComponent,
    AgregarRepuestoDialogComponent,
    TrashComponent,
    AgregarZonaComponent,
    AsignarFechaComponent,
    StepperPedidoComponent,
    RepuestosFilter,
    TicketFilter,
    AdminsFilter,
    FallasFilter,
    CalificarConsultaComponent,
    StarsMeterComponent,
    RankingTecnicosComponent,
    AgregarRepuestoDialogComponent,
    MapChartComponent,
    AdminTicketReviewDialogComponent,
    ListadoRepuestosComponent,
    AsignacionesTecnicoComponent,
    RankingTecnicoParticularComponent,
    NuevaSolicitudDeReppuestosComponent,
    ResetPasswordComponent,
    OrdenarAlfabeticamentePipe,
    ListadoFallasComponent,
    TecnicosModificacioinesComponent,
    ActualizacionMasivaPreciosFallasComponent,
    ConfigComponent,
    ImportarProductosComponent,
    ImportarRepuestosComponent,
    MyTicketsComponent,
    TerminosComponent,
    WhatsappMessagesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    AngularFontAwesomeModule,
    ChartsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgbModule.forRoot(),
    ToastrModule.forRoot(
      {timeOut: 10000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,}
    )
  ],
  entryComponents: [ 
    ConfirmComponent, 
    AsignarTecnicoComponent, 
    AgregarZonaComponent,
    AsignarFechaComponent,
    AgregarRepuestoDialogComponent,
    AdminTicketReviewDialogComponent,
    NuevaSolicitudDeReppuestosComponent,
    ActualizacionMasivaPreciosFallasComponent,
    ImportarProductosComponent,
    ImportarRepuestosComponent
  ],
  providers: [ 
    ConfirmService,
    AsignarTecnicoService,
    AgregarZonaService,
    AsignarFechaService,
    AgregarRepuestoDialogServie,
    NuevaSolicitudDeRepuestosService,
    ActualizacionMasivaPreciosFallasService,
    ThemeService ,
    AdminTicketReviewDialogService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedResponseInterceptor, multi: true }    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
